import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '咪咕悦看超级会员'
      // title: '咪咕悦看超级会员'
    }
  },
  {
    path: '/guangdong_migu',
    name: 'guangdong_migu',
    component: () => import('@/views/GuangDong_migu.vue'),
    meta: {
      // title: '咪咕悦看超级会员'
      title: '咪咕悦看超级会员'
    }
  },
  {
    path: '/chongqin',
    name: 'chongqin',
    component: () => import('@/views/ChongQin.vue'),
    meta: {
      title: '咪咕悦看超级会员'
      // title: '咪咕悦看超级会员'
    }
  },
  {
    path: '/home_zun',
    name: 'home_zun',
    component: () => import('@/views/HomeView_zun.vue'),
    meta: {
      title: '咪咕悦读尊享会员'
    }
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // 尝试从路由元信息中获取标题
  const title = to.meta.title;
  if (title) {
    document.title = `${title}`;
  } else {
    document.title = `${title}`;
  }

  next();
});

export default router;

